<template>
  <v-app>
    <v-main>
      <router-view />
    </v-main>
    <AccessibilityPanel />

    <div class="social-sidebar d-flex flex-column align-center shadow-soft">
      <div 
        v-for="(network, index) in socialNetworks" 
        :key="index" 
        class="social-item mb-2"
      >
        <a :href="network.link" target="_blank" :title="network.name">
          <img 
            :width="30" 
            :src="network.icon" 
            :alt="network.name" 
            class="social-icon transition-swing" 
          />
        </a>
      </div>
    </div>
  </v-app>
</template>

<script>
import AccessibilityPanel from '@/components/Home/AccessibilityPanel.vue';

export default {
  name: 'App',
  components: { AccessibilityPanel },

  data() {
    return {
      // Ma'lumotlarni markazlashgan holda boshqarish
      socialNetworks: [
        { 
          name: 'Telegram', 
          link: 'https://t.me/ipkuz', 
          icon: require('./assets/telegram.png') 
        },
        // { 
        //   name: 'Instagram', 
        //   link: 'https://www.instagram.com/geologiya_fanlari_universitet/', 
        //   icon: require('./assets/instagram.png') 
        // },
        // { 
        //   name: 'Facebook', 
        //   link: 'https://www.facebook.com/geoscience.official', 
        //   icon: require('./assets/facebook.png') 
        // },
        { 
          name: 'YouTube', 
          link: 'https://www.youtube.com/channel/UCv-HSxvCzCmjQnliv5Xw4ag', 
          icon: require('./assets/youtube.png') 
        },
        { 
          name: 'Web', 
          link: 'https://malakageo.uz/', 
          icon: require('./assets/web.png') 
        },
      ]
    }
  }
}
</script>

<style scoped>
.social-sidebar {
  position: fixed;
  right: 0;
  bottom: 80px;
  z-index: 100;
  background-color: #ffffffe5;
  border-radius: 12px 0 0 12px;
  padding: 12px 8px;
  box-shadow: -4px 0 15px rgba(0, 0, 0, 0.3);
  border: 1px solid #f0f0f0;
  transition: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
}
.social-sidebar:hover {
  padding-right: 12px;
  box-shadow: -6px 0 20px rgba(0, 0, 0, 0.15);
}
.social-item {
  transition: transform 0.2s ease-in-out;
}
.social-item:hover {
  transform: scale(1.05) translateX(-1px);
}
.murojaat-section {
  border-top: 1.5px solid #f5f5f5;
  width: 100%;
  display: flex;
  justify-content: center;
}
@media (max-width: 600px) {
  .social-sidebar {
    bottom: 20px; 
    padding: 8px 4px;
  }
  .social-item img {
    width: 32px !important; 
  }
}
</style>